/**
 * Credits: reads `shell/credits.generated.json` (asset pipeline output) when present, else a static
 * list of the known third-party pieces.
 */
import { Sheet } from '../ui';

interface CreditLine {
  name: string;
  author?: string;
  license: string;
  url?: string;
}

const STATIC_CREDITS: CreditLine[] = [
  { name: 'Twemoji', author: 'Twitter', license: 'CC-BY 4.0', url: 'https://github.com/twitter/twemoji' },
  { name: 'Noto Emoji', author: 'Google', license: 'OFL 1.1', url: 'https://github.com/googlefonts/noto-emoji' },
  { name: 'Bricolage Grotesque, Shrikhand, Hanken Grotesk, Space Mono', license: 'OFL 1.1', url: 'https://fonts.google.com' },
  { name: 'Kenney Casino Audio, Impact, Interface, Jingles', author: 'Kenney', license: 'CC0', url: 'https://kenney.nl' },
  { name: 'Kenney Particle Pack', author: 'Kenney', license: 'CC0', url: 'https://kenney.nl' },
  { name: 'game-icons.net icons', author: 'various', license: 'CC-BY 3.0', url: 'https://game-icons.net' },
  { name: 'GSAP', author: 'Webflow', license: 'GSAP Standard License', url: 'https://gsap.com' },
  { name: 'PixiJS, pixi-filters', license: 'MIT', url: 'https://pixijs.com' },
  { name: 'Paper Shaders', license: 'PolyForm Shield', url: 'https://shaders.paper.design' },
  { name: 'Bot play logic ported from TricksterBots', author: 'Trickster Cards', license: 'MIT', url: 'https://github.com/TricksterCards/TricksterBots' },
];

const generated = import.meta.glob<{ default: CreditLine[] }>('../credits.generated.json', { eager: true });
const lines: CreditLine[] = Object.values(generated)[0]?.default ?? STATIC_CREDITS;

export function CreditsSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  return (
    <Sheet open={open} title="Credits" onClose={onClose} testId="credits">
      <div className="prose">
        <p className="muted small">Spades Night is built on open work. Thank you.</p>
        <ul>
          {lines.map((l) => (
            <li key={l.name}>
              {l.url ? (
                <a className="link" href={l.url} target="_blank" rel="noreferrer">
                  {l.name}
                </a>
              ) : (
                l.name
              )}
              {l.author ? ` by ${l.author}` : ''} · {l.license}
            </li>
          ))}
        </ul>
      </div>
    </Sheet>
  );
}
